// extracted by mini-css-extract-plugin
module.exports = {"form":"BrandFormPage_form__3nwWM","formSection":"BrandFormPage_formSection__3agIF","availableSwitch":"BrandFormPage_availableSwitch__2Zwrv"};